import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

type APIPayload = {
    store_id: string;
    email: string;
    name: string;
    phone: string;
    is_active: boolean;

};

export const addMember = async (payload: APIPayload) => {
    try {
        const response = await Axios.post("/users/add-member", payload);
        return response.data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useAddMember = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload: APIPayload) => addMember(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["get-all-members"] });
            console.log({ data });
        },
        onError: (error) => {
            toast.error("Unable to add user.", { description: error.message });
            console.log({ error });
        },
    });
};
